import { FC } from "react";
import type { UserProps } from "../types";
import { Column, Row } from "../../../../components/containers";
import StatusPicture from "../../../../components/status-picture";
import {
  AlignItems,
  JustifyContent,
} from "../../../../components/containers/types";
import { usePopupStore, useThemeStore } from "../../../../stores";
import { Heading, Text } from "../../../../components/typography";
import UserProfilePopup from "./user-profile-popup";

const User: FC<UserProps> = (props) => {
  const theme = useThemeStore((state) => state.theme);
  const setPopupBody = usePopupStore((state) => state.setPopupBody);

  const onClick = (): void => {
    setPopupBody(<UserProfilePopup {...props} />);
  };

  return (
    <Row
      background={theme.overlay}
      style={{ width: "100%", minHeight: 80, borderRadius: 15 }}
      gap={10}
      className="cursor-pointer"
      props={{ onClick }}
    >
      <StatusPicture
        src={props.pic}
        type={"small"}
        status={props.status}
        style={{ marginRight: "1rem" }}
      />
      <Column
        style={{ width: "100%" }}
        alignItems={AlignItems.Start}
        justifyContent={JustifyContent.Between}
        gap={5}
      >
        <Heading size={16} color={theme.textOnOverlay}>
          {props.fullname}
        </Heading>
        <Text color={theme.icon} size={12}>
          {props.role}
        </Text>
      </Column>
    </Row>
  );
};

export default User;
